
// 批量设置公开画面
Vue.component("necessary_tag", {
  props: {
    course_info: {
      type: Array,
      default: {}
    },
    info: {
      type: Array,
      default: {}
    }
  },
  template: `
  <div class="necessary_tag">
    <!-- 全部必学 -->
    <template v-if="course_info.necessaryLearn == 1"><div class="necessary must">必学</div></template>
    <!-- 部分必学 -->
    <template v-else>
        <!-- 按类型 -->
        <template v-if="course_info.necessaryLearnType.includes(0)">
            <!-- 必学类型: 0按类型 1自定义 2音视频课件 3文档类课件 4图片类课件 5其他类课件 6作业 7参考资料 8超链接 -->
            <div class="necessary must" v-if="
            (course_info.necessaryLearnType.includes(2) && (info.resourse_type == 'video' || info.resourse_type == 'audio') && info.resource_attributes == 'courseware') ||
            (course_info.necessaryLearnType.includes(3) && info.resourse_type == 'document' && info.resource_attributes == 'courseware') ||
            (course_info.necessaryLearnType.includes(4) && info.resourse_type == 'picture' && info.resource_attributes == 'courseware') ||
            (course_info.necessaryLearnType.includes(5) && !info.resourse_type && info.resource_attributes == 'courseware') ||
            (course_info.necessaryLearnType.includes(6) && info.resource_attributes == 'homework') ||
            (course_info.necessaryLearnType.includes(7) && info.resource_attributes == 'reference') ||
            (course_info.necessaryLearnType.includes(8) && info.resource_attributes == 'hyperlink')
            ">必学</div>
            <div class="necessary" v-else>选学</div>
        </template>
        <!-- 自定义 -->
        <template v-else-if="course_info.necessaryLearnType.includes(1)">
            <div class="necessary must" v-if="course_info.necessaryLearnResourceId.includes(info.guid_)">必学</div>
            <div class="necessary" v-else>选学</div>
        </template>
    </template>
</div>
  `,
});